import { LoadState } from "../../constants/enums";
import { IReports, IReportsState } from "./types";



export const defaultReports: IReports = {
    courses_name: "",
    batch: "",
    academic_year: 1,
    total_fee: 0,
    payment_mode: "debit_card",
    organizations_name: "",
    organizations_uuid: ""
}


export const defaultReportsState: IReportsState = {
    list:{
        data: [],
        loading: LoadState.NotLoaded,
        totalRecords: 0,
        error: null,
    },
    reports:{
        data: defaultReports,
        loading: LoadState.NotLoaded,
        error: null
    },
    amount:{
        totalamount: 0,
    }
}